// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@guestsupply/App/Store/Selectors/SettingsSelectors";
import { checkoutPages } from "@guestsupply/XDL/constants";
import HeaderPhoneIcon from "@guestsupply/XDL/Icons/HeaderPhone";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    isCheckoutPage: checkoutPages.includes(getCurrentPage(state).type),
    checkoutPhoneNumber: getSettingsCollection(state).customSettings.checkoutPhoneNumber,
});

interface OwnProps {
    extendedStyles?: CheckoutHeaderPhoneStyles;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface CheckoutHeaderPhoneStyles {
    link?: LinkPresentationProps;
    phoneIcon?: IconProps;
    phoneText?: TypographyProps;
}

export const checkoutHeaderPhoneStyles: CheckoutHeaderPhoneStyles = {};

const CheckoutHeaderPhone = ({ isCheckoutPage, extendedStyles, checkoutPhoneNumber }: Props) => {
    const [styles] = React.useState(() => mergeWithCss(checkoutHeaderPhoneStyles, extendedStyles));

    if (!isCheckoutPage || !checkoutPhoneNumber) {
        return null;
    }

    return (
        <Link href={`tel:${checkoutPhoneNumber}`} {...styles.link} aria-label="call support">
            {checkoutPhoneNumber}
        </Link>
    );
};

export default connect(mapStateToProps)(CheckoutHeaderPhone);
